import axios from 'axios';
import { tokenStorage, usernameStorage, clearAllAuthData } from '../utils/encryptedCookie';

const api = axios.create({
  baseURL: 
    window.env?.REACT_APP_BASE_URL && window.env.REACT_APP_BASE_URL !== "REACT_APP_BASE_URL_PLACEHOLDER"
      ? window.env.REACT_APP_BASE_URL
      : 'http://localhost:8081/api/v1',
});

api.interceptors.request.use(
  (config) => {
    const token = tokenStorage.get();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      logout();
    }

    return Promise.reject(error);
  }
);

const logout = () => {
  const username = usernameStorage.get() || '';
  clearAllAuthData();
  if (username) {
    sessionStorage.removeItem(`pinVerified_${username}`);
  }
  sessionStorage.clear();
  window.location.href = "/login";
};

export default api;